import { HttpClient, HttpParams } from '@angular/common/http';
import { EnvironmentLoaderService } from './environment-loader.service';
import { Injectable, inject } from '@angular/core';
import {
  CreateUserWithAppInvitationRequest,
  CreateUserWithoutInvitationRequest,
  SendUserInvitations,
} from 'src/app/features/charging-users/charging-user-create-modal/charging-user-create.model';
import { PagedResult } from '../models/paging';
import {
  Invitation,
  InvitationSearchEvent,
} from 'src/app/features/charging-users/charging-user-invitations-modal/charging-user-invitations-modal.model';

@Injectable({
  providedIn: 'root',
})
export class UserInvitationService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiUrl: string;

  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/admin/invitation';
  }

  createUserWithAppInvitation(model: CreateUserWithAppInvitationRequest) {
    const url = this.apiUrl + '/createChargingUserWithAppInvitation';

    return this.http.post<number>(url, model);
  }

  createUserWithoutInvitation(model: CreateUserWithoutInvitationRequest) {
    const url = this.apiUrl + '/createUserWithoutInvitation';

    return this.http.post<number>(url, model);
  }

  sendInvitations(model: SendUserInvitations) {
    const url = this.apiUrl + '/sendInvitations';

    return this.http.post<string>(url, model);
  }

  getInvitations(searchEvent?: InvitationSearchEvent) {
    let params = new HttpParams();

    if (searchEvent?.organizationId) {
      params = params.append('organizationId', searchEvent.organizationId?.toString());
    }
    if (searchEvent?.status) {
      params = params.append('invitationStatus', searchEvent.status?.toString());
    }
    if (searchEvent?.query) {
      params = params.append('query', searchEvent.query);
    }
    if (searchEvent?.paging?.pageIndex) {
      params = params.append('page', searchEvent.paging.pageIndex);
    }
    if (searchEvent?.paging?.pageSize) {
      params = params.append('pageSize', searchEvent.paging.pageSize);
    }
    if (searchEvent?.sorting?.active) {
      params = params.append('sortby', searchEvent.sorting?.active);

      if (searchEvent?.sorting?.direction) {
        params = params.append('sortdirection', searchEvent.sorting?.direction);
      }
    }

    return this.http.get<PagedResult<Invitation>>(this.apiUrl, {
      params,
    });
  }
}
